import { reportError } from './error-reporting-service';

export default class StorageService {
  static _cache: Record<string, string | null> = {};

  static getItem(key: string): string | null {
    let value = this._cache[key];
    if (value) {
      return value;
    }

    try {
      value = window.localStorage.getItem(key);
      this._cache[key] = value;
      return value;
    } catch (error) {
      reportError({ error });
      return null;
    }
  }

  static setItem(key: string, value: string): void {
    this._cache[key] = value;

    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      reportError({ error });
    }
  }

  static removeItem(key: string): void {
    delete this._cache[key];
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      reportError({ error });
    }
  }

  static clear(): void {
    this._cache = {};
    try {
      window.localStorage.clear();
    } catch (error) {
      reportError({ error });
    }
  }
}
